export const ORGANISATIONS = [
  {
    id: "organisation_77436E14-0DBC-44C6-8F2B-400DFB056724",
    name: "The Raindrop Company",
    description: "Quadruple charity giving.",
    supporters: 0,
  },
  {
    id: "organisation_EEAA5B09-5126-4C37-A7DF-2506B237DD93",
    name: "British Heart Foundation",
    description: "Helping research into heart issues.",
    tags: ["tag_7F357390-FDA1-493A-B902-C21AAC5B2C26"],
    supporters: 221,
    logo_url:
      "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/raindrop_demo/logo_heart.png",
  },
  {
    id: "organisation_5B24D981-EA29-4346-ABE9-239113577F7A",
    name: "Teenage Cancer Trust",
    description:
      "Teenage Cancer Trust is the only UK charity dedicated to providing specialist care for young people with cancer.",
    supporters: 12,
    tags: ["tag_7F357390-FDA1-493A-B902-C21AAC5B2C26"],
    logo_url:
      "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/raindrop_demo/logo_teenager.png",
  },
  {
    id: "organisation_76CFE4A217-F6D0-4E69-B393-215EB8B38B8B",
    name: "British Red Cross",
    description:
      "For over 150 years the British Red Cross have helped people cope with disasters and conflicts worldwide.",
    supporters: 12,
    tags: ["tag_F34CD685-FBF9-4FBB-BDE0-DC4FE87C4065"],
    logo_url:
      "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/raindrop_demo/logo_redcross.png",
  },
  {
    id: "organisation_0936773D-02C6-4AFB-BCEF-03984D03EBFF",
    name: "Crisis",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    descriptionLong:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    supporters: 8,
    url: "https://www.mind.org.uk/",
    urlLogo:
      "https://d3nag6e3dddgye.cloudfront.net/uploads/container/6125/icon/mind_charity.jpeg",
    tags: ["tag_BAD0DDF8-66C7-4852-A9B7-90C6FC0FBC6E"],
    logo_url:
      "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/raindrop_demo/logo_crisis.png",
  },
  {
    id: "organisation_670DF629-1A05-4BED-99FD-1AD11D577EF3",
    name: "Black Lives Matter",
    description: "Helping people in the U.S.A.",
    supporters: 250,
    featured: true,
    logo_url:
      "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/raindrop_demo/logo_black.png",
    tags: ["tag_5B0DA33E-F132-48CD-A5D8-5B165069C2A7"],
  },

  {
    id: "organisation_B628EB2B-ED3A-4785-8866-BD0C1784124C",
    name: "Ukrainian Civilian Support",
    description: "Helping to feed and shelter displaced Ukraneans.",
    tags: ["tag_F34CD685-FBF9-4FBB-BDE0-DC4FE87C4065"],
    supporters: 10,
    featured: true,
    logo_url:
      "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/raindrop_demo/logo_ukraine.png",
  },

  {
    id: "organisation_B62837BFE94B-4339-4832-8999-FA0EACD366C8",
    name: "New Incentives",
    description: "Doing good things.",
    supporters: 345,
    tags: ["tag_F81FD717-C910-4AA0-860A-2B20F2021880"],
    logo_url:
      "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/raindrop_demo/logo_new.png",
  },

  {
    id: "organisation_762837BFE94B-4339-4832-8999-FA0EACD366C2",
    name: "KidsCan",
    description:
      "The KidsCan charity addresses child poverty in New Zealand by providing food, clothing, health items, and educational support to children in need..",
    supporters: 12,
    logo_url:
      "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/raindrop_demo/logo_kidscan.png",
  },

  {
    id: "organisation_2DD326AB-7FD2-42D1-BA2C-1162C10125B1",
    name: "Muslim Hands",
    description:
      "Since 1993, Muslim Hands has been dedicated to helping those affected by poverty, conflict and natural disasters worldwide.",
    supporters: 12,
    logo_url:
      "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/raindrop_demo/logo_muslim.png",
  },

  {
    id: "organisation_4302B3ED-CE5F-4DA1-B13F-95118EAE0113",
    name: "Stonewall Housing",
    description:
      "Stonewall Housing is the leading national charity supporting LGBTQ+ people in the UK who are experiencing homelessness.",
    supporters: 12,
    tags: ["tag_5B0DA33E-F132-48CD-A5D8-5B165069C2A7"],
    logo_url:
      "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/raindrop_demo/logo_stonewall.png",
  },

  {
    id: "organisation_D2635FD1-F716-46A1-97EA-A881110632F5",
    name: "Woman's Aid",
    description:
      "Their mission is to be the voice of victims and survivors of domestic violence, while aiming to create a culture where domestic violence is not tolerated and where society empowers victims and survivors while holding abusers accountable.",
    supporters: 8,
    tags: [
      "tag_F81FD717-C910-4AA0-860A-2B20F2021880",
      "tag_5FF6FD0C-DEB2-4AF6-819B-8334B3A48C24",
      "tag_491465A0-8C12-4328-B860-A193E0C4144B",
    ],
    logo_url:
      "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/raindrop_demo/logo_women.png",
  },

  {
    id: "organisation_0E1E65BD-8741-4819-9844-C716A511F7C4",
    name: "Mind",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    descriptionLong:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    supporters: 8,
    url: "https://www.mind.org.uk/",
    urlLogo:
      "https://d3nag6e3dddgye.cloudfront.net/uploads/container/6125/icon/mind_charity.jpeg",
    tags: ["tag_5FF6FD0C-DEB2-4AF6-819B-8334B3A48C24"],
    logo_url:
      "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/raindrop_demo/logo_mind.png",
  },

  {
    id: "organisation_8EB9A3E2-16E3-4F33-A94E-589464872DB0",
    name: "Medical Aid for Palestinians",
    description: "Helping people in the U.S.A.",
    supporters: 250,
    tags: [
      "tag_F34CD685-FBF9-4FBB-BDE0-DC4FE87C4065",
      "tag_F81FD717-C910-4AA0-860A-2B20F2021880",
      "tag_F34CD685-FBF9-4FBB-BDE0-DC4FE87C4065",
    ],
    featured: true,
    logo_url:
      "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/raindrop_demo/logo_palestine.png",
  },
  {
    id: "organisation_8EB9A3E2-16E3-4F33-A94E-589464872DB1",
    name: "Jewish Federations of North America",
    description: "Helping the people of Israel",
    supporters: 250,
    tags: ["tag_F34CD685-FBF9-4FBB-BDE0-DC4FE87C4065"],
    featured: true,
    logo_url:
      "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/raindrop_demo/logo_jewish.png",
  },
];

export const ACTIVITIES = [
  {
    id: "organisation_activity_1F9E51B5-C95A-4FE3-9270-AE9217837D9E",
    organisation: {
      id: "organisation_670DF629-1A05-4BED-99FD-1AD11D577EF3",
      name: "Black Lives Matter",
      logo_url:
        "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/raindrop_demo/logo_black.png",
    },
    text: "Thanks to you, we've just provided education for 800 students in Louisiana.",
    created_at: "10 minutes ago",
  },
  {
    id: "organisation_activity_C7CF2265-972F-47E5-B166-01582FF3CCD9",
    organisation: {
      id: "organisation_B62837BFE94B-4339-4832-8999-FA0EACD366C8",
      name: "New Incentives",
    },
    text: "Thanks to you, whale hunting in Somalia has been legislatively prohibited.",
    created_at: "Yesterday",
  },
  {
    id: "organisation_activity_87B630B3-D773-40DD-8CE7-3DCB8D434F88",
    organisation: {
      id: "organisation_B628EB2B-ED3A-4785-8866-BD0C1784124C",
      name: "Ukrainian Civilian Support",
    },
    text: "You’ve just let us protect and shelter 2,000 families in Kyiv.",
    created_at: "2 days ago",
  },
  {
    id: "organisation_activity_9469FAE0-94D1-4639-99A1-7147DE6D5701",
    organisation: {
      id: "organisation_670DF629-1A05-4BED-99FD-1AD11D577EF3",
      name: "Black Lives Matter",
      logo_url:
        "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/raindrop_demo/logo_black.png",
    },
    text: "You're support has help us elect the first African-american woman to the Ohio state supreme court.",
    created_at: "23 Nov",
  },
  {
    id: "organisation_activity_9469FAE1-94D1-4639-99A1-7147DE6D5701",
    organisation: {
      id: "organisation_EEAA5B09-5126-4C37-A7DF-2506B237DD93",
      name: "British Heart Foundation",
    },
    text: "Thanks to you, heart attack risk has been decreased in new mothers.",
    created_at: "22 Nov",
  },
  {
    id: "organisation_activity_9469FAE2-94D1-4639-99A1-7147DE6D5701",
    organisation: {
      id: "organisation_670DF629-1A05-4BED-99FD-1AD11D577EF3",
      name: "Black Lives Matter",
      logo_url:
        "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/raindrop_demo/logo_black.png",
    },
    text: "We've just hosted the largest memorial to remember George Floyd.",
    created_at: "22 Nov",
  },
  {
    id: "organisation_activity_080EC137-DC91-47C8-B8FD-589A995A8867",
    organisation: {
      id: "organisation_B628EB2B-ED3A-4785-8866-BD0C1784124C",
      name: "Ukrainian Civilian Support",
    },
    text: "You've helped us relocate 20,000 people from the wreckage at Mariupol.",
    created_at: "18 Nov",
  },
  {
    id: "organisation_activity_87B630B9-D773-40DD-8CE7-3DCB8D434F88",
    organisation: {
      id: "organisation_B628EB2B-ED3A-4785-8866-BD0C1784124C",
      name: "Ukrainian Civilian Support",
    },
    text: "We've used your support to provide blankets and food to 5,000 displaced Ukrainians.",
    created_at: "15 Nov",
  },
];

export const SHAREABLE_CONTENT = [
  {
    id: "shareable_content_AF1FBA33-33A6-4BE6-9940-A306C2DDCBE1",
    organisationId: "organisation_EEAA5B09-5126-4C37-A7DF-2506B237DD93",
    hasTexture: false,
    active: true,
    color: "#9FCCD1",
    note: "British Heart Foundation",
  },
  {
    id: "shareable_content_EC3C0414-FE2C-41C3-972C-FF21898779D6",
    organisationId: "organisation_B628EB2B-ED3A-4785-8866-BD0C1784124C",
    hasTexture: true,
    active: true,
    note: "Ukrainian Civilian Support",
  },
  {
    id: "shareable_content_D26E7EBD-C6DD-4171-85A4-1D1747E7ABC2",
    organisationId: "organisation_762837BFE94B-4339-4832-8999-FA0EACD366C2",
    hasTexture: false,
    color: "#326390dd",
    note: "Kids Can",
  },
  {
    id: "shareable_content_B1A22119-D9B7-4E45-B76B-7040F97EABF1",
    organisationId: "organisation_670DF629-1A05-4BED-99FD-1AD11D577EF3",
    hasTexture: false,
    color: "black",
    active: true,
    note: "Black Lives Matter",
  },
];

export const PLANS = [
  {
    id: "plan__53AD4C62-FE26-4C1E-8DA5-D02017D839E9",
    userId: "account_user__DA625BEA-E1B1-4D6E-B09C-7F8D99F139DA",
    isSupportingRaindrop: true,
    sausages: [],
  },
  {
    id: "plan__53AD4C62-FE26-4C1E-8DA5-D02017D839E9",
    userId: "account_user__BA625BEA-E1B1-4D6E-B09C-7F8D99F139DA",
    isSupportingRaindrop: true,
    sausages: [],
  },
  {
    id: "plan__53AD4C62-FE26-4C1E-8DA5-D02017D839E8",
    userId: "account_user__WA625BEA-E1B1-4D6E-B09C-7F8D99F139DA",
    isSupportingRaindrop: true,
    sausages: [
      {
        organisationId: "organisation_8EB9A3E2-16E3-4F33-A94E-589464872DB0",
        percentage: 50,
      },
      {
        organisationId: "organisation_8EB9A3E2-16E3-4F33-A94E-589464872DB1",
        percentage: 50,
      },
    ],
  },
  {
    id: "plan__83AD4C62-FE26-4C1E-8DA5-D02017D839ES",
    userId: "account_user__AN625BEA-E1B1-4D6E-B09C-7F8D99F139DP",
    isSupportingRaindrop: false,
    sausages: [
      {
        organisationId: "organisation_D2635FD1-F716-46A1-97EA-A881110632F5",
        percentage: 100,
      },
    ],
  },
];

export const getPlanForUser = (userId) => {
  return PLANS.find((p) => p.userId === userId);
};

export const getRaindropOrganisationId = () => {
  return "organisation_77436E14-0DBC-44C6-8F2B-400DFB056724";
};
